export default function (
    element,
    { modifiers },
    {
        data: {
            attrs: {
                href: { name },
            },
        },
    },
) {
    if (name === undefined) {
        return;
    }

    let value = name;

    if (modifiers.fuzzy) {
        const parts = name.split('.');

        if (parts.length > 1) {
            parts.splice(-1, 1, '*'); // remove last segment of route and replace with fuzzy token
            value = parts.join('.');
        }
    }

    if (route().current(value)) {
        element.classList.add('active');
    }
}
